import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch applicant details by userId
export const fetchApplicantDetails = createAsyncThunk(
  'applicantDetails/fetchApplicantDetails',
  async ({userId,jobId }, { rejectWithValue }) => {
    // console.log("Job ID thunk:", jobId, "User ID:", userId); // Check values here
    try {
      // console.log("Job ID thunk22:", jobId, "User ID:", userId); // Check values here
      const ticketToken = sessionStorage.getItem('ticketToken');
      // console.log("ticketToken:", ticketToken);
      // console.log("Fetching applicant details for userId:", userId); // Log the userId
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/provider/get-applicant-details`,
        { userId: userId, jobId: jobId },
        { headers: { Authorization: `Bearer ${ticketToken}` } }
      );
      // console.log("Server response for applicant details:", response.data); // Log the server response

      if (response.data && response.data.success) {
        // return response.data.applicants[0]; // Return the first applicant object
        const applicant = response.data.applicants[0]; // Assuming we get applicants array
        // const isHired = applicant?.isHired || false; // Extract isHired or default to false
        const isHired = applicant?.isHired || false;
        // console.log(`Applicant ${applicant.userId} - ${applicant.FullName} is ${isHired ? 'Hired' : 'Not Hired'}`);

        // return applicant;
        // console.log(isHired);

        return {
          ...applicant,
          isHired, // Ensure isHired is explicitly set
        };
      } else {
        throw new Error(response.data?.message || 'Failed to fetch applicant details.');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const applicantDetailsSlice = createSlice({
  name: 'applicantDetails',
  initialState: {
    applicantDetails: null,
    isHired: false,
    loading: false,
    error: null,
  },
  reducers: {
    resetApplicantDetails: (state) => {
      console.log("Resetting applicant details"); // Log reset action
      state.applicantDetails = null;
      // state.isHired = false;
      state.loading = false;
      state.error = null;
    },
    updateApplicantHiredStatus: (state, action) => {
      console.log("Updating isHired status to:", action.payload);
      state.isHired = action.payload;
      if (state.applicantDetails) {
        console.log("Current applicant details before update:", state.applicantDetails);
        state.applicantDetails.isHired = action.payload; // Update the nested applicant details as well
        console.log("Updated applicant details:", state.applicantDetails);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicantDetails.pending, (state) => {
        console.log("fetchApplicantDetails pending"); // Log pending action
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicantDetails.fulfilled, (state, action) => {
        console.log("fetchApplicantDetails fulfilled with data:", action.payload); // Log fulfilled action and data
        state.loading = false;
        state.applicantDetails = action.payload; // Set applicant details to fetched data
        state.isHired = action.payload.isHired || false; // Set isHired with a default value if not present
      })
      .addCase(fetchApplicantDetails.rejected, (state, action) => {
        console.error("fetchApplicantDetails rejected with error:", action.payload); // Log rejected action and error
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetApplicantDetails, updateApplicantHiredStatus } = applicantDetailsSlice.actions;
export default applicantDetailsSlice.reducer;
